/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.13.0
 */

import { Fragment } from 'react';

import { SkeletonParagraph } from '../../../../../components/common';
import { ESkeletonKind } from '../../../../../components/common/Skeleton/skeletonTypes';
import { SubscriberIdSkeletonStyled } from '../../styled/PageSubscriberIdStyled';

const paragraphStyle = { width: 300 };
const btnStyle = { width: 200, marginTop: 16 };

export const SubscriberIdInfoGeneralSkeleton = () => {
    return (
        <Fragment>
            <SubscriberIdSkeletonStyled className="subscriber-id-info__block">
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL} style={paragraphStyle}/>
                <SkeletonParagraph kind={ESkeletonKind.BUTTON_ROUND} style={btnStyle}/>
            </SubscriberIdSkeletonStyled>

            <SubscriberIdSkeletonStyled className="subscriber-id-info__block">
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL} style={paragraphStyle}/>
            </SubscriberIdSkeletonStyled>

            <SubscriberIdSkeletonStyled className="subscriber-id-info__block">
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL} style={paragraphStyle}/>
            </SubscriberIdSkeletonStyled>

            <SubscriberIdSkeletonStyled className="subscriber-id-info__block">
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL} style={paragraphStyle}/>
            </SubscriberIdSkeletonStyled>

            <SubscriberIdSkeletonStyled className="subscriber-id-info__block">
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL} style={paragraphStyle}/>
            </SubscriberIdSkeletonStyled>
        </Fragment>
    );
};

export const SubscriberIdInfoTariffSkeleton = () => {
    const rangeStyle = { height: 12 };
    const rangeTitleStyle = { width: 150, marginBottom: 8 };
    return (
        <Fragment>
            <SubscriberIdSkeletonStyled
                className="subscriber-id-info__block subscriber-id-info__tariff"
                style={{ gridColumnStart: 1 }}
            >
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL} style={paragraphStyle}/>
                <div className="tariff__description" style={{ marginTop: 24 }}>
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL}/>
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL}/>
                    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                </div>
                <SkeletonParagraph className="tariff__btn" kind={ESkeletonKind.BUTTON_ROUND} style={btnStyle}/>
            </SubscriberIdSkeletonStyled>

            <SubscriberIdSkeletonStyled className="subscriber-id-info__block subscriber-id-info__tariff-discounts">
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL} style={{ marginBottom: 24 }}/>
                <div className="tariff-discounts__group">
                    <div>
                        <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL} style={rangeTitleStyle}/>
                        <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL} style={rangeTitleStyle}/>
                    </div>
                    <SkeletonParagraph
                        kind={ESkeletonKind.BUTTON_ROUND}
                        style={rangeStyle}
                    />
                </div>
                <div className="subscriber-id-info__range">
                    <div className="subscriber-id-info__range-title">
                        <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL} style={rangeTitleStyle}/>
                        <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL} style={rangeTitleStyle}/>
                    </div>
                    <SkeletonParagraph
                        className="subscriber-id-info__range-row"
                        kind={ESkeletonKind.BUTTON_ROUND}
                        style={rangeStyle}
                    />
                </div>
            </SubscriberIdSkeletonStyled>
        </Fragment>
    );
};
